export const unixTimestampToISO = (seconds: number, nanoseconds: number): string => {
    const date = new Date(seconds * 1000 + nanoseconds / 1000000)
    return date.toISOString()
  }